import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { ActiveProfileProvider } from './context/ActiveProfileContext';
import ProtectedRoute from './auth/ProtectedRoute';
import MainLayout from './components/layout/MainLayout';
import Dashboard from './pages/Dashboard';
import VoiceProfile from './pages/VoiceProfile';
import Prospects from './pages/Prospects';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';
import Inboxes from './pages/Inboxes';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Register from './pages/Register';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected routes */}
          <Route
            element={
              <ProtectedRoute>
                <ActiveProfileProvider>
                  <MainLayout />
                </ActiveProfileProvider>
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/voice-profile" element={<VoiceProfile />} />
            <Route path="/prospects" element={<Prospects />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/campaigns/:campaignId" element={<CampaignDetail />} />
            <Route path="/inboxes" element={<Inboxes />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
